import angular from 'angular';
import { react2angular } from 'react18-to-angularjs';
import CompliancyContainer from '../modules/compliancy/CompliancyContainer';
import DocumentsContainer from '../modules/documents/DocumentsContainer';
import EmailsContainer from '../modules/documents/EmailsContainer';

import HomeDashboardContainer from '../modules/home/HomeDashboardContainer';
import InteractionsContainer from '../modules/interactions/InteractionsContainer';
import InteractionOverviewContainer from '../modules/interactions/overview/InteractionOverviewContainer';
import ToInvoiceContainer from '../modules/invoicing/toInvoice/ToInvoiceContainer';
import JobDetailContainer from '../modules/jobs/JobDetailContainer';
import JobOverviewContainer from '../modules/jobs/JobOverviewContainer';
import NotificationOverviewContainer from '../modules/notifications/NotificationOverviewContainer';
import NotificationSettingsContainer from '../modules/notifications/NotificationSettingsContainer';
import PriceGridContainer from '../modules/pricegrids/PriceGridContainer';
import RelationAuditContainer from '../modules/relations/audit/RelationAuditContainer';
import BudgetOverviewContainer from '../modules/relations/budgets/BudgetOverviewContainer';
import InvoiceStreamContainer from '../modules/relations/invoiceStreamOverview/InvoiceStreamContainer';
import RelationOverviewContainer from '../modules/relations/overview/RelationOverviewContainer';
import PlannedRegistrationOverviewContainer from '../modules/relations/plannedRegistrationOverview/PlannedRegistrationOverviewContainer';
import TaskScheduleOverviewContainer from '../modules/relations/taskScheduleOverview/TaskScheduleOverviewContainer';
import DeviationOverviewContainer from '../modules/relations/deviationOverview/DeviationOverviewContainer';
import AbsencePerEmployeeContainer from '../modules/reporting/absencePerEmployee/AbsencePerEmployeeContainer';
import AbsenceCalendarContainer from '../modules/reporting/absenceCalendar/AbsenceCalendarContainer';
import HoursPerEmployeeReportContainer from '../modules/reporting/hoursPerEmployee/HoursPerEmployeeReportContainer';
import InvoicingHistoryContainer from '../modules/reporting/invoicingHistory/InvoicingHistoryContainer';
import RegistrationsPerResourceCategoryContainer from '../modules/reporting/registrationsPer/RegistrationsPerResourceCategoryContainer';
import RegistrationsPerTaskTemplateContainer from '../modules/reporting/registrationsPer/RegistrationsPerTaskTemplateContainer';
import RegistrationsPerUserContainer from '../modules/reporting/registrationsPer/RegistrationsPerUserContainer';
import RegistrationsPerRelationContainer from '../modules/reporting/registrationsPer/relation/RegistrationsPerRelationContainer';
import PerformanceBalanceContainer from '../modules/reporting/performanceBalance/PerformanceBalanceContainer';
import RelationRentabilityContainer from '../modules/reporting/relationRentability/RelationRentabilityContainer';
import AssignmentTemplateContainer from '../modules/settings/AssignmentTemplates/AssignmentTemplateContainer';
import TagSettingsContainer from '../modules/settings/Tags/TagSettingsContainer';
import DocumentTreeConfiguration from '../modules/settings/Documents/DocumentTreeConfiguration';
import DocumentTemplateContainer from '../modules/settings/DocumentTemplates/DocumentTemplateContainer';
import InvoiceSchedulesContainer from '../modules/settings/InvoiceSchedules/InvoiceSchedulesContainer';
import TeamsContainer from '../modules/settings/teams/TeamsContainer';
import WorkflowConfigurationContainer from '../modules/settings/WorkflowConfiguration/WorkflowConfigurationContainer';
import TaskDashboardContainer from '../modules/tasks/dashboard/TaskDashboardContainer';
import TaskListContainer from '../modules/tasks/taskList/TaskListContainer';
import TaskOverviewContainer from '../modules/tasks/taskOverview/TaskOverviewContainer';
import TaskProgressPerEmployeeContainer from '../modules/tasks/taskProgressPerEmployee/TaskProgressPerEmployeeContainer';
import RegistrationFormTestContainer from '../shared/components/registration/RegistrationFormTestContainer';
import IntraCompanyBillingContainer from '../modules/invoicing/intraCompany/IntraCompanyBillingContainer';
import HrmOverviewContainer from '../modules/hrm/overview/HrmOverviewContainer';
import InteractionTemplateSettingsContainer from '../modules/settings/InteractionTemplates/InteractionTemplateSettingsContainer';
import TrainingOverviewContainer from '@/modules/training/TrainingOverviewContainer';
import TrainingEmployeeOverviewContainer from '@/modules/training/TrainingEmployeeOverviewContainer';
import EmployeeOverviewContainer from '../modules/settings/Employees/EmployeeOverviewContainer';
import EmployeeProfileOverviewContainer from '../modules/settings/Employees/Profiles/EmployeeProfileOverviewContainer';

import CreateTimerRegistrationModal from '@/modules/registrations/modals/CreateTimerRegistrationModal';
import RegistrationOverviewContainer from '@/modules/registrations/RegistrationOverviewContainer';
import AppProviders, {
  withDataProvider,
  withModalProvider,
  withQueryClient,
  withTaskTimerProvider,
} from '@/shared/providers/AppProviders';
import TaskboardContainer from '../modules/tasks/taskboard/TaskboardContainer';
import AccessTokensContainer from '@/modules/profile/accessTokens/accessTokens';
import MyProfileContainer from '@/modules/profile/MyProfileContainer';
import DocumentDetailsModal from '@/modules/documents/details/DocumentDetailsModal';
import TaskDetailsModal from '@/modules/tasks/taskDetails/TaskDetailsModal';
import SingleRelationMailModal from '@/shared/components/email/SingleRelationMailModal';
import CreateToDoModal from '@/modules/tasks/CreateToDoModal';
import InvoicedRelationsModal from '@/modules/relations/relationfile/InvoicedRelationsModal';
import RelationSharepointLinkModal from '@/modules/relations/relationfile/RelationSharepointLinkModal';
import FiscalVehicleModal from '@/modules/relations/fiscal/modals/FiscalVehicleModal';
import FiscalLoanModal from '@/modules/relations/fiscal/modals/FiscalLoanModal';
import FiscalInsuranceModal from '@/modules/relations/fiscal/modals/FiscalInsuranceModal';
import FiscalCostModal from '@/modules/relations/fiscal/modals/FiscalCostModal';
import FiscalRealEstateModal from '@/modules/relations/fiscal/modals/FiscalRealEstateModal';

import TenantRoleContainer from '@/modules/settings/TenantRoles/TenantRoleContainer';
import AssignmentAnalysisEmployeeRelationMatrix from '@/modules/hrm/assignmentAnalysis/AssignmentAnalysisEmployeeRelationMatrix';
import AssignmentAnalysisEmployeeTaskMatrix from '@/modules/hrm/assignmentAnalysis/AssignmentAnalysisEmployeeTaskMatrix';
import WeekPlannerContainer from '@/modules/tasks/weekplanner/WeekPlannerContainer';
import { withTaskflowBillingProvider } from '@/shared/providers/TaskflowBillingProvider';
import AssignmentAnalysisEmployeeCapacityReport from '@/modules/hrm/assignmentAnalysis/AssignmentAnalysisEmployeeCapacityReport';
import GeneralSettingsContainer from '@/modules/settings/GeneralSettings/GeneralSettingsContainer';
import LegalEntitiesContainer from '@/modules/legalEntities/LegalEntitiesContainer';
import CompanyContainer from '@/modules/settings/Company/CompanyContainer';
import LicenseContainer from '@/modules/settings/License/LicenseContainer';

const componentsModule = angular
  .module('cloudX.components', [])
  //
  // add here all your top level react components
  //
  .component(
    'relationCompliancyContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(CompliancyContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component('currencySymbol', {
    template: '{{$ctrl.currencySymbol}}',
    controller: [
      'dataCache',
      function CurrencySymbolController(dataCache) {
        var currencyCode = dataCache.getDefaultCompany().currencyCode;
        this.currencySymbol = '€';

        if (currencyCode == 'ZAR') {
          this.currencySymbol = 'R';
        }
      },
    ],
  })
  .component(
    'documentsContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(DocumentsContainer)))),
      ['searchParams', 'documentId'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'documentDetailsModal',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(DocumentDetailsModal)))),
      ['documentId', 'show', 'onClose', 'onSave'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'taskDetailsModal',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(TaskDetailsModal)))),
      ['task', 'show', 'onClose', 'onSave', 'showSendEmailButton'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'createToDoModal',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(CreateToDoModal)))),
      ['relationId', 'show', 'onClose', 'onSave'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'fiscalVehicleModal',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(FiscalVehicleModal)))),
      ['show', 'onClose', 'onSave', 'relationId', 'vehicle', 'documents', 'onCreateRelation'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'fiscalLoanModal',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(FiscalLoanModal)))),
      ['show', 'onClose', 'onSave', 'relationId', 'loan', 'documents'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'fiscalInsuranceModal',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(FiscalInsuranceModal)))),
      ['show', 'onClose', 'onSave', 'relationId', 'insurance', 'documents', 'onCreateRelation'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'fiscalCostModal',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(FiscalCostModal)))),
      ['show', 'onClose', 'onSave', 'relationId', 'cost', 'documents', 'onCreateRelation'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'fiscalRealEstateModal',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(FiscalRealEstateModal)))),
      ['show', 'onClose', 'onSave', 'relationId', 'realEstate', 'documents', 'existingRealEstates'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'invoicedRelationsModal',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(InvoicedRelationsModal)))),
      ['relationId', 'show', 'onClose', 'onSave'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'relationSharepointLinkModal',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(RelationSharepointLinkModal))),
      ),
      ['relationId', 'show', 'onClose'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'emailsContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(EmailsContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'relationOverviewContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(RelationOverviewContainer)))),
      ['searchParams'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'jobOverviewContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(JobOverviewContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'jobDetailContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(JobDetailContainer)))),
      ['jobId'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'invoiceSchedulesContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(InvoiceSchedulesContainer)))),
      ['editScheduleId'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'workflowConfigurationContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(WorkflowConfigurationContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'priceGridContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(PriceGridContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'documentTreeConfiguration',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(DocumentTreeConfiguration)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'tagSettingsContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(TagSettingsContainer)))),
      ['tab'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'interactionTemplateSettingsContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(InteractionTemplateSettingsContainer))),
      ),
      ['tab'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'documentTemplateContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(DocumentTemplateContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'teamsContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(TeamsContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'relationRentabilityContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(RelationRentabilityContainer))),
      ),
      ['searchParams'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'performanceBalanceContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(PerformanceBalanceContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'invoicingHistoryContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(InvoicingHistoryContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'hoursPerEmployeeReportContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(HoursPerEmployeeReportContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'toInvoiceContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(ToInvoiceContainer)))),
      ['searchParams'],
      ['$state', '$translate', 'dataCache', 'invoiceDialogsSvc'],
    ),
  )
  .component(
    'intraCompanyBillingContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(IntraCompanyBillingContainer))),
      ),
      ['searchParams'],
      ['$state', '$translate', 'dataCache', 'invoiceDialogsSvc'],
    ),
  )
  .component(
    'notificationOverviewContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(NotificationOverviewContainer))),
      ),
      ['searchParams'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'interactionsContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(InteractionsContainer)))),
      ['searchParams', 'openMailModal'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'interactionOverviewContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(InteractionOverviewContainer))),
      ),
      ['searchParams'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'taskScheduleOverviewContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(TaskScheduleOverviewContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'deviationOverviewContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(DeviationOverviewContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache', 'relationDialogsSvc'],
    ),
  )
  .component(
    'invoiceStreamContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(InvoiceStreamContainer)))),
      [],
      ['$state', '$translate', 'dataCache', 'invoiceDialogsSvc'],
    ),
  )
  .component(
    'assignmentTemplateContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(AssignmentTemplateContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'registrationsPerRelationContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(RegistrationsPerRelationContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'registrationsPerResourceCategoryContainer',
    react2angular(
      AppProviders(
        withQueryClient(
          withDataProvider(withModalProvider(RegistrationsPerResourceCategoryContainer)),
        ),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'registrationsPerTaskTemplateContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(RegistrationsPerTaskTemplateContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'registrationsPerUserContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(RegistrationsPerUserContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'homeDashboardContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(HomeDashboardContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'plannedRegistrationOverviewContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(PlannedRegistrationOverviewContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'registrationOverviewContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(RegistrationOverviewContainer))),
      ),
      ['searchParams'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'registrationFormTestContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(RegistrationFormTestContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'notificationSettingsContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(NotificationSettingsContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'absencePerEmployeeContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(AbsencePerEmployeeContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'absenceCalendarContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(AbsenceCalendarContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'relationAuditContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(RelationAuditContainer)))),
      ['relationId'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'budgetOverviewContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(BudgetOverviewContainer)))),
      [],
      ['$state', '$translate', 'dataCache', 'invoiceDialogsSvc'],
    ),
  )
  .component(
    'taskOverviewContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(TaskOverviewContainer)))),
      ['searchParams'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'taskProgressPerEmployeeContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(TaskProgressPerEmployeeContainer))),
      ),
      ['searchParams'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'taskListContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(TaskListContainer)))),
      ['searchParams', 'taskId', 'sort', 'desc'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'taskDashboardContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(TaskDashboardContainer)))),
      ['searchParams'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'taskboardContainer',
    react2angular(
      AppProviders(
        withQueryClient(
          withDataProvider(
            withModalProvider(
              withTaskTimerProvider(withTaskflowBillingProvider(TaskboardContainer)),
            ),
          ),
        ),
      ),
      [
        'relation',
        'invoiceStreamId',
        'taskTemplateId',
        'plannedTaskId',
        'kpi',
        'userId',
        'onlySubtasksForAssignedUser',
        'userIsNextAssignedUser',
        'openPlannedTaskDetailModal',
        'deadlineFrom',
        'deadlineUntil',
        'createTaskForRelation',
      ],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'createTimerRegistrationModal',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(CreateTimerRegistrationModal))),
      ),
      ['initialValue', 'onClose', 'onSave', 'show'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'accessTokensContainer',
    react2angular(
      AppProviders(
        withQueryClient(
          withDataProvider(withModalProvider(withTaskTimerProvider(AccessTokensContainer))),
        ),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'myProfileContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(MyProfileContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'hrmOverviewContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(HrmOverviewContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'tenantRoleContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(TenantRoleContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'trainingOverviewContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(TrainingOverviewContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'trainingEmployeeOverviewContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(TrainingEmployeeOverviewContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'assignmentAnalysisEmployeeRelationMatrix',
    react2angular(
      AppProviders(
        withQueryClient(
          withDataProvider(withModalProvider(AssignmentAnalysisEmployeeRelationMatrix)),
        ),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'assignmentAnalysisEmployeeTaskMatrix',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(AssignmentAnalysisEmployeeTaskMatrix))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'assignmentAnalysisEmployeeCapacityReport',
    react2angular(
      AppProviders(
        withQueryClient(
          withDataProvider(withModalProvider(AssignmentAnalysisEmployeeCapacityReport)),
        ),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'employeeOverviewContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(EmployeeOverviewContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'employeeProfileOverviewContainer',
    react2angular(
      AppProviders(
        withQueryClient(withDataProvider(withModalProvider(EmployeeProfileOverviewContainer))),
      ),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'weekPlannerContainer',
    react2angular(
      AppProviders(
        withQueryClient(
          withDataProvider(withModalProvider(withTaskTimerProvider(WeekPlannerContainer))),
        ),
      ),
      ['filters'],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'generalSettingsContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(GeneralSettingsContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'licenseContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(LicenseContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'legalEntitiesContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(LegalEntitiesContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  )
  .component(
    'companyContainer',
    react2angular(
      AppProviders(withQueryClient(withDataProvider(withModalProvider(CompanyContainer)))),
      [],
      ['$state', '$translate', 'dataCache'],
    ),
  );

export default componentsModule.name;
